import { useMutation } from "@apollo/client/react";
import { DELETE_CLIENT_EMAIL_CONNECTION } from "../../mutations/documentHandler/deleteClientEmailConnection";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";

export const useDeleteClientEmailConnection = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [deleteClientEmailConnection, { data, loading, error }] = useMutation(
    DELETE_CLIENT_EMAIL_CONNECTION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    }
  );

  return { deleteClientEmailConnection, data, loading, error };
};
